import React, { useMemo } from 'react';

const TrackTableLoaderRow = ({ headCells, actionColumnWidthClass }: any) => {
    const tableCells = useMemo(
        () => [
            {
                key: 'orderId',
                htmlDynamic: (
                    <td className="max-w-[170px] min-w-[170px]">
                        <div className="flex items-center gap-x-1.5">
                            <div className="custom-loading h-3.5 w-24" />
                        </div>
                    </td>
                ),
            },
            {
                key: 'carrierName',
                htmlDynamic: (
                    <td className="min-w-[175px] max-w-[175px]">
                        <div className="flex items-center gap-x-2">
                            <span className="custom-loading truncate">Lorem Ipsum</span>
                        </div>
                    </td>
                ),
            },
            {
                key: 'orderType',
                htmlDynamic: (
                    <td className="min-w-[130px] max-w-[130px]">
                        <div className="custom-loading h-[18px] w-14 rounded-md" />
                    </td>
                ),
            },
            {
                key: 'orderStatus',
                htmlDynamic: (
                    <td className="min-w-[140px] max-w-[140px]">
                        <div className="custom-loading h-[18px] w-20 rounded-md" />
                    </td>
                ),
            },
            {
                key: 'pickupDate',
                htmlDynamic: (
                    <td className="min-w-[150px] max-w-[150px] w-[150px]">
                        <div className="custom-loading h-3.5 w-28" />
                    </td>
                ),
            },
            {
                key: 'pickupType',
                htmlDynamic: (
                    <td className="min-w-[130px] max-w-[130px] w-[130px]">
                        <div className="custom-loading h-3.5 w-24" />
                    </td>
                ),
            },
            {
                key: 'pickupTime',
                htmlDynamic: (
                    <td className="min-w-[120px] max-w-[120px] w-[120px]">
                        <div className="custom-loading h-3.5 w-20" />
                    </td>
                ),
            },
            {
                key: 'deliveryDate',
                htmlDynamic: (
                    <td className="min-w-[150px] max-w-[150px] w-[150px]">
                        <div className="custom-loading h-3.5 w-28" />
                    </td>
                ),
            },
            {
                key: 'deliveryType',
                htmlDynamic: (
                    <td className="min-w-[130px] max-w-[130px] w-[130px]">
                        <div className="custom-loading h-3.5 w-24" />
                    </td>
                ),
            },
            {
                key: 'deliveryTime',
                htmlDynamic: (
                    <td className="min-w-[120px] max-w-[120px] w-[120px]">
                        <div className="custom-loading h-3.5 w-20" />
                    </td>
                ),
            },
            {
                key: 'shipperCity',
                htmlDynamic: (
                    <td className="min-w-[185px] max-w-[185px]">
                        <span className="custom-loading">Lorem Ipsum dolor</span>
                    </td>
                ),
            },
            {
                key: 'consigneeCity',
                htmlDynamic: (
                    <td className="min-w-[185px] max-w-[185px]">
                        <span className="custom-loading">Lorem Ipsum dolor</span>
                    </td>
                ),
            },
            {
                key: 'action',
                htmlDynamic: (
                    <td className={`table-cell-with-tooltip sticky right-0 bg-inherit z-[1] ${actionColumnWidthClass || 'min-w-[64px] max-w-[64px] w-[64px]'}`}>
                        <div className="justify-end items-center gap-2 flex h-full table-col-tooltip-space-common-xs">
                            <span className="custom-loading block w-4 h-4 rounded" />
                            <span className="custom-loading block w-4 h-4 rounded" />
                        </div>
                    </td>
                ),
            },
        ],
        [actionColumnWidthClass]
    );

    return (
        <>
            {headCells
                ?.filter((cell: any) => cell.visible)
                .map((cell: any) => {
                    if (cell.id === 'checkbox') {
                        return (
                            <React.Fragment key="checkbox">
                                <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip">
                                    <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                                        <span className="custom-loading block w-4 h-4 rounded" />
                                    </div>
                                </td>
                            </React.Fragment>
                        );
                    }

                    const matched = tableCells.find((tCell) => tCell.key === cell.id);

                    if (!matched) return null;

                    return <React.Fragment key={cell.id}>{matched.htmlDynamic}</React.Fragment>;
                })}
        </>
    );
};

export default TrackTableLoaderRow;
